import React, {Component} from 'react'
import { Referrals } from './pages'


class App extends Component {
    componentDidMount() {
      const urlParams = new URLSearchParams(window.location.search);
      const isReferrals = urlParams.get('referrals');
  
      if (!isReferrals) {
        window.location.href = 'https://aleph.vc'; // Redirect if not referrals
      }
    }
  
    render() {
      return (
        <div>
          <Referrals />
        </div>
      );
    }
  }
  
export default App



// WEBPACK FOOTER //
// ./src/App.js